import React from 'react';
import { hot } from 'react-hot-loader';
import Image from '../Image/Image';
import Video from '../Video/Video';
import VideoEmbed from '../VideoEmbed/VideoEmbed';
import s from './BackgroundMedia.scss';

const BackgroundMedia = ({ content, column, uid, first = false, focalPoint = false, fill = false, lazyLoad, visible }) => {
	const extraProps = {};
	if (first && !lazyLoad) lazyLoad = 'eager';
	if (!lazyLoad) lazyLoad = 'lazy';

	if (focalPoint) {
		const objectPosition = `${(parseFloat(focalPoint.x, 10) * 100).toFixed(1)}% ${(parseFloat(focalPoint.y, 10) * 100).toFixed(1)}%`;
		extraProps.style = { objectPosition };
		extraProps['data-object-fit'] = 'cover';
		extraProps['data-object-position'] = objectPosition;
	}
	if (fill) extraProps['data-object-fit'] = 'cover';

	const media = !Array.isArray(content.image) ? [content.image] : content.image;
	const embeds = !Array.isArray(content.embedLink) ? [content.embedLink] : content.embedLink;
	const containerProps = {};
	let hasOverlay = false;

	const returnContent = media.filter((image) => image).map((image) => {
		if (!image) return null;
		if (/\.mp4$/.test(image.url)) return <div key={image.url.replace('media.stutterheim.com', 'stutterheim.com')} className={[s.media_item, s.media_item__video].join(' ')}><Video content={{ src: image.url, autoplay: 1, loop: 1, muted: 1 }} column={column} extraProps={extraProps} lazyLoad={lazyLoad} enableEvents={false} /></div>;
		return (
			<div key={image.url} className={[s.media_item, s.media_item__image].join(' ')}>
				<Image content={{ image }} column={column} extraProps={extraProps} first={first} lazyLoad={lazyLoad} />
			</div>
		);
	});

	embeds.forEach((embed, i) => {
		if (!embed) return;
		returnContent[i] = <div key={embed.url} className={[s.media_item, s.media_item__video].join(' ')}><VideoEmbed content={{ url: embed }} uid={uid} extraProps={extraProps} lazyLoad={lazyLoad} /></div>;
	});

	if (content?.overlayColor?.[0] || content?.overlayColor?.[1]) {
		hasOverlay = true;
		returnContent.push((
			<div key="overlay" className={s.media_overlay}>
				<div style={{ ...(content.overlayColor[0] ? { backgroundColor: content.overlayColor[0] } : {}) }} />
				<div style={{ ...(content.overlayColor[1] ? { backgroundColor: content.overlayColor[1] } : {}) }} />
			</div>
		));
	}

	return (
		<div className={[s.media, (visible ? s.media__visible : null), (hasOverlay ? s.media__overlayed : null), (fill ? s.media__fill : null), (returnContent.length > 1 ? s.media__multiple : null)].join(' ')} {...containerProps}>
			{ returnContent }
		</div>
	);
};

export default hot(module)(BackgroundMedia);
